import { useCallback, useContext } from 'react'
import { useStore } from 'react-redux'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { OfferPageActions, type OfferPageMultiRoomMode } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { getFlashRoomModeTransition } from './flashSameRoomSelection'

/** Flash owns its selection transition; other products keep their existing mode command. */
export default function useFlashRoomModeChange() {
  const state = useContext(OfferPageStateContext)
  const dispatch = useOfferPageDispatch()
  const store = useStore<App.State>()
  return useCallback((mode: OfferPageMultiRoomMode) => {
    if (mode === state.multiRoomMode) return
    const transition = getFlashRoomModeTransition(state, store.getState(), mode)
    dispatch({ type: OfferPageActions.toggleMultiRoomMode, multiRoomMode: mode, ...transition })
  }, [dispatch, state, store])
}
